import {
  projectTypes,
  qualityLevels,
  DESIGN_STYLES,
  CONFIGURATOR_EXTRAS_META,
  configuratorExtraFees,
  computeEstimateRange,
  formatUsdRange,
  ESTIMATE_PRICE_CONTEXT_UA,
  ESTIMATE_PRICE_CONTEXT_EN,
} from './estimator';

const DIVIDER = '══════════════════════════════════════';

function labelById(list, id, isUA) {
  const row = list.find((x) => x.id === id);
  if (!row) return String(id);
  return isUA ? row.labelUA : row.labelEN;
}

function styleLabel(styleId, isUA) {
  return labelById(DESIGN_STYLES, styleId, isUA);
}

function extraLabel(key, isUA) {
  const row = CONFIGURATOR_EXTRAS_META.find((x) => x.key === key);
  if (!row) return key;
  return isUA ? row.labelUA : row.labelEN;
}

/**
 * Human-readable plain text for mailto (no JSON).
 */
export function buildConfiguratorEmailBody(state, pricing, isUA) {
  const pt = labelById(projectTypes, state.projectType, isUA);
  const ql = labelById(qualityLevels, state.level, isUA);
  const style = styleLabel(state.style, isUA);
  const m2 = isUA ? 'м²' : 'm²';
  const context = isUA ? ESTIMATE_PRICE_CONTEXT_UA : ESTIMATE_PRICE_CONTEXT_EN;
  const { min, max } = computeEstimateRange(pricing.total);
  const rangeLine = formatUsdRange(min, max);

  const lines = [];

  if (isUA) {
    lines.push('SATI Architects');
    lines.push(DIVIDER);
    lines.push('ЗАПИТ З КОНСТРУКТОРА ПРОЄКТУ');
    lines.push(DIVIDER);
    lines.push('');
    lines.push('ПРОЄКТ');
    lines.push(`Тип: ${pt}`);
    lines.push(`Площа: ${state.area} ${m2}`);
    lines.push(`Рівень оздоблення: ${ql}`);
    lines.push(`Спальні / санвузли: ${state.bedrooms} / ${state.bathrooms}`);
    lines.push(`Стиль: ${style}`);
    lines.push('');
    lines.push(DIVIDER);
    lines.push('ДОДАТКОВІ ОПЦІЇ');
    lines.push(DIVIDER);
  } else {
    lines.push('SATI Architects');
    lines.push(DIVIDER);
    lines.push('PROJECT CONFIGURATOR ENQUIRY');
    lines.push(DIVIDER);
    lines.push('');
    lines.push('PROJECT');
    lines.push(`Type: ${pt}`);
    lines.push(`Area: ${state.area} ${m2}`);
    lines.push(`Finish level: ${ql}`);
    lines.push(`Bedrooms / bathrooms: ${state.bedrooms} / ${state.bathrooms}`);
    lines.push(`Style: ${style}`);
    lines.push('');
    lines.push(DIVIDER);
    lines.push('ADD-ONS');
    lines.push(DIVIDER);
  }

  const selectedExtras = Object.keys(configuratorExtraFees).filter((k) => state.extras?.[k]);
  if (selectedExtras.length === 0) {
    lines.push(isUA ? '(не обрано)' : '(none selected)');
  } else {
    selectedExtras.forEach((k) => {
      lines.push(`• ${extraLabel(k, isUA)} (+$${configuratorExtraFees[k].toLocaleString()})`);
    });
  }

  lines.push('');
  lines.push(DIVIDER);
  lines.push(isUA ? 'ОРІЄНТОВНИЙ ДІАПАЗОН (USD)' : 'INDICATIVE RANGE (USD)');
  lines.push(DIVIDER);
  lines.push(isUA ? `Діапазон: ${rangeLine}` : `Range: ${rangeLine}`);
  lines.push('');
  lines.push(context);
  lines.push('');
  lines.push(DIVIDER);
  lines.push(isUA ? 'КОНТАКТ' : 'CONTACT');
  lines.push(DIVIDER);

  const c = state.contact || {};
  lines.push(`${isUA ? 'Ім’я' : 'Name'}: ${c.name || '—'}`);
  lines.push(`Email: ${c.email || '—'}`);
  lines.push(`${isUA ? 'Телефон' : 'Phone'}: ${c.phone || '—'}`);
  if (c.notes) {
    lines.push('');
    lines.push(isUA ? 'Коментар:' : 'Notes:');
    lines.push(c.notes);
  }

  lines.push('');
  lines.push(DIVIDER);
  lines.push(isUA ? 'Надіслано з sati-architects.com/estimate' : 'Sent via sati-architects.com/estimate');

  return lines.join('\n');
}

export function configuratorEmailSubject() {
  return 'SATI — Project enquiry (Configurator)';
}
